import { Icon } from 'antd'
import styled from 'styled-components'

export const StyledIcon = styled(Icon)<{ color?: string }>`
  padding: 0 4px;
  ${({ color }) => ({ color: color })}
  > svg {
    height: 1.05rem;
    width: 1.05rem;
  }
`
